import React, { useState } from "react";
import styles from "./UpdateProfile.module.css";
import Navbar from "../../components/ui/Navbar";
import Menu from "../../components/ui/Menu";
import Footer from "../../components/ui/Footer";
import Auth from "../../utils/api/Auth";
import { useDispatch, useSelector } from "react-redux";
import { userDataActions } from "../../store/redux-store/Index";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function UpdateProfile(props) {
  const dispatch = useDispatch();

  const token = useSelector((state) => state.userData.loginData.token);
  const personalInfo = useSelector((state) => state.userData.personalInfo);

  const [fullname, setFullname] = useState(String(personalInfo?.fullname || ""));
  const [phone_no, setPhoneNo] = useState(String(personalInfo?.phone_no || ""));
  const [loading, setLoading] = useState(false);

  const closeMenuHandler = () => {
    props.setShowMenu(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!fullname.trim()) {
      toast.error("Full name is required.", {
        position: "top-left",
        autoClose: 4000,
        theme: "dark",
      });
      return;
    }

    if (!phone_no.trim()) {
      toast.error("Phone number is required.", {
        position: "top-left",
        autoClose: 4000,
        theme: "dark",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await Auth.updateProfileHandler({ token, fullname, phone_no });
      // Update Redux store with new values
      dispatch(
        userDataActions.generalUserData({
          ...personalInfo,
          fullname,
          phone_no,
        })
      );
      toast.success(
        res?.data?.message || "Profile updated successfully.",
        {
          position: "top-left",
          autoClose: 4000,
          theme: "dark",
        }
      );
    } catch (err) {
      toast.error(
        err?.response?.data?.message || "Failed to update profile. Please try again.",
        {
          position: "top-left",
          autoClose: 5000,
          theme: "dark",
        }
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <ToastContainer />
      <div className="menu" onClick={closeMenuHandler}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="Update Profile" setShowMenu={props.setShowMenu} />
      <div className={styles.container}>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.field}>
            <label className={styles.label} htmlFor="fullname">
              Full Name
            </label>
            <input
              id="fullname"
              className={styles.input}
              type="text"
              placeholder="Enter your full name"
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
            />
          </div>

          <div className={styles.field}>
            <label className={styles.label} htmlFor="phone_no">
              Phone Number
            </label>
            <input
              id="phone_no"
              className={styles.input}
              type="tel"
              placeholder="Enter your phone number"
              value={phone_no}
              onChange={(e) => setPhoneNo(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className={styles.button}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Profile"}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}

export default UpdateProfile;
